import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {EmployeeService} from "../../../../../services/employee.service";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {InductionService} from "../induction.service";
import {
  AddRowPopUpComponent
} from "../../../../counseling/components/counselling-induction/add-edit-induction/add-row-pop-up/add-row-pop-up.component";
import {AddEditInductionComponent} from "../add-edit-induction/add-edit-induction.component";

@Component({
  selector: 'app-education-induction-table',
  templateUrl: './education-induction-table.component.html',
  styleUrls: ['./education-induction-table.component.scss']
})
export class EducationInductionTableComponent implements OnInit {
  // tableForm!: FormGroup;
  // inductionId:any;
  // allInductor$: Observable<any[]>;
  // selectInductor = new FormControl();
  // displayedColumns = [
  //   'srNo',
  //   'topic',
  //   'centreName',
  //   'teacherName',
  //   'date',
  //   'content',
  //   'suggestions',
  //   'actions'
  // ];
  // constructor(private dialog: MatDialog,
  //             private fb: FormBuilder,
  //             private route: ActivatedRoute,
  //             private router: Router,
  //             private snackBar: MatSnackBar,
  //             private mEmployeeService : EmployeeService,
  //             private inductionService: InductionService) {
  //   this.allInductor$ = this.mEmployeeService.getTeachers();
  // }
  // showSnack(message: string) {
  //   this.snackBar.open(message, 'OK', {
  //     duration: 3000,
  //     horizontalPosition: 'center',
  //     verticalPosition: 'bottom',
  //     panelClass: ['success-snackbar']
  //   });
  // }

  ngOnInit() {
  }

  //
  // ngOnInit(): void {
  //   this.tableForm = this.fb.group({
  //     rows: this.fb.array([])
  //   });
  //   // Get ID from URL
  //   this.inductionId = this.route.snapshot.paramMap.get("id");
  //
  //   if (this.inductionId) {
  //     this.loadInductionData(this.inductionId);   // EDIT MODE
  //   }
  // }
  // loadInductionData(id: string) {
  //   this.inductionService.getDataById(id).subscribe((doc: any) => {
  //     if (!doc) return;
  //     this.selectInductor.setValue(doc.inductionFor);
  //     // Clear formArray
  //     this.rows.clear();
  //     // Add rows from Firestore
  //     doc.rows.forEach((row: any) => {
  //       console.log(row)
  //       this.rows.push(this.createRow(row));
  //     });
  //
  //     // Refresh table
  //     this.tableForm.setControl("rows", this.fb.array(this.rows.controls));
  //   });
  // }
  //
  // get rows() {
  //   return this.tableForm.get('rows') as any;
  // }
  // createRow(data: any) {
  //   return this.fb.group({
  //     orderNo: data.orderNo,
  //     topic: data.topic || '',
  //     centreName: data.centreName || '',
  //     centreCode: data.centreCode || '',
  //     teacherName: data.teacherName || '',
  //     date: data.date ? (data.date.toDate ? data.date.toDate() : data.date) : '',
  //     content: data.content || '',
  //     suggestions: data.suggestions || '',
  //   });
  // }
  // AddNewRow() {
  //   if (!this.selectInductor.value) {
  //     alert("Please select a counsellor first.");
  //     return;
  //   }
  //
  //   const dialogRef = this.dialog.open(AddEditInductionComponent, {
  //     disableClose: true,
  //     height: '600px',
  //     width: '900px',
  //   });
  //
  //   dialogRef.afterClosed().subscribe(async (rowData) => {
  //     if (!rowData) return;
  //
  //     rowData.orderNo = this.rows.length + 1;
  //
  //     // -------- CREATE NEW DOCUMENT FIRST TIME -------- //
  //     if (!this.inductionId) {
  //       const userData = JSON.parse(localStorage.getItem('userData')!);
  //
  //       const payload = {
  //         inductionFor: this.selectInductor.value,
  //         submittedBy: userData?.userName || '',
  //         rows: [rowData]
  //       };
  //
  //       const docRef = await this.inductionService.create(payload);
  //       this.inductionId = docRef.id;
  //
  //       // update UI
  //       this.rows.push(this.createRow(rowData));
  //       this.tableForm.setControl('rows', this.fb.array(this.rows.controls));
  //       this.showSnack("Row added successfully!");
  //       return;
  //     }
  //
  //     // -------- UPDATE EXISTING DOCUMENT -------- //
  //     this.rows.push(this.createRow(rowData));
  //     const updatedRows = this.tableForm.value.rows;
  //
  //     this.inductionService.updateRows(this.inductionId, updatedRows)
  //       .then(() => this.showSnack("New row added successfully!"));
  //   });
  // }
  //
  // AddNewRow2() {
  //   const dialogRef = this.dialog.open(AddRowPopUpComponent, {
  //     disableClose: true,
  //     height: '600px',
  //     width: '900px',
  //   });
  //
  //   dialogRef.afterClosed().subscribe((rowData) => {
  //     if (!rowData) return;
  //
  //     rowData.orderNo = this.rows.length + 1;
  //
  //     this.rows.push(this.createRow(rowData));
  //
  //     // 🔥 Important: refresh table
  //     this.tableForm.setControl('rows', this.fb.array(this.rows.controls));
  //   });
  // }
  // deleteRow(index: number) {
  //   if (!confirm("Are you sure you want to delete this row?")) return;
  //
  //   this.rows.removeAt(index);
  //
  //   // Fix order numbers
  //   this.rows.controls.forEach((ctrl: any, i: number) => {
  //     ctrl.patchValue({ orderNo: i + 1 });
  //   });
  //
  //   // Update in Firestore
  //   if (this.inductionId) {
  //     this.inductionService.updateRows(this.inductionId, this.rows.value)
  //       .then(() => this.showSnack("Row deleted successfully!"));
  //   } else {
  //     this.showSnack("Row deleted!");
  //   }
  //
  //   // Refresh table
  //   this.tableForm.setControl("rows", this.fb.array(this.rows.controls));
  // }
  //
  // cellClick(index:number , field:any){
  //   this.openEditRowDialog(index, field);
  // }
  // onCancel(){
  //   this.router.navigate(['/home/education/induction-list']);
  // }
  //
  // openEditRowDialog(index: number, focusField?: string) {
  //   const currentRow = this.rows.at(index).value;
  //   const dialogRef = this.dialog.open(AddEditInductionComponent, {
  //     disableClose: true,
  //     height: '600px',
  //     width: '900px',
  //     data: { ...currentRow, focusField }
  //   });
  //
  //   dialogRef.afterClosed().subscribe((updatedRow) => {
  //     if (!updatedRow) return;
  //
  //     updatedRow.orderNo = index + 1;
  //
  //     // Update UI
  //     this.rows.at(index).patchValue({...updatedRow, date:updatedRow.date.toDate()});
  //     this.tableForm.setControl('rows', this.fb.array(this.rows.controls));
  //     if (this.inductionId) {
  //       const updatedRows = this.tableForm.value.rows;
  //
  //       this.inductionService.updateRows(this.inductionId, updatedRows)
  //         .then(() => this.showSnack("Row updated successfully!"));
  //     } else {
  //       this.showSnack("Row updated!");
  //     }
  //   })
  // }
  //
  // saveInduction() {
  //   const userData = JSON.parse(localStorage.getItem('userData')!);
  //   const payload = {
  //     inductionFor: this.selectInductor.value,
  //     submittedBy: userData?.userName || '',
  //     rows: this.tableForm.value.rows
  //   };
  //
  //   if (this.inductionId) {
  //     this.inductionService.update(this.inductionId, payload)
  //       .then(() => {
  //         this.showSnack("Induction Updated Successfully!");
  //         this.dialog.closeAll()
  //       });
  //
  //   } else {
  //     this.inductionService.create(payload)
  //       .then(() => {
  //         this.showSnack("Induction Saved Successfully!");
  //         this.dialog.closeAll()
  //       });
  //   }
  // }

}
